/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  CreateContactMemoRequestContactMemo,
  CreateContactMemoRequestContactMemoFromJSON,
  CreateContactMemoRequestContactMemoFromJSONTyped,
  CreateContactMemoRequestContactMemoToJSON
} from './CreateContactMemoRequestContactMemo'

/**
 *
 * @export
 * @interface UpdateContactMemoRequest
 */
export interface UpdateContactMemoRequest {
  /**
   *
   * @type {CreateContactMemoRequestContactMemo}
   * @memberof UpdateContactMemoRequest
   */
  contactMemo?: CreateContactMemoRequestContactMemo
}

export function UpdateContactMemoRequestFromJSON(json: any): UpdateContactMemoRequest {
  return UpdateContactMemoRequestFromJSONTyped(json, false)
}

export function UpdateContactMemoRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateContactMemoRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    contactMemo: !exists(json, 'contact_memo')
      ? undefined
      : CreateContactMemoRequestContactMemoFromJSON(json['contact_memo'])
  }
}

export function UpdateContactMemoRequestToJSON(value?: UpdateContactMemoRequest | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    contact_memo: CreateContactMemoRequestContactMemoToJSON(value.contactMemo)
  }
}
